// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__POu3H","info":"Panel_info__Id8NG","note":"Panel_note__eWahC","close":"Panel_close__LLxx5","btns":"Panel_btns__rg4e+","button":"Panel_button__YGQLe"};